import axios from 'axios';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/exchange/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/exchange/';

class ExchangeService {

  getRateByCode(code) {
    return axios.get(`${API_URL}${code}`);
  }

  getRates() {
    return axios.get(`${API_URL}`);
  }
}

export default new ExchangeService();



// WEBPACK FOOTER //
// ./src/services/exchange.service.js